<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
  <g clip-path="url(#chevron-up-double__a)">
    <path d="M21.735 14.291a1 1 0 0 1-1.416 0L12 5.957l-8.319 8.334a1 1 0 0 1-1.416 0l-1.56-1.563a1 1 0 0 1 0-1.413L11.292.709a1 1 0 0 1 1.416 0l10.587 10.606a1 1 0 0 1 0 1.413l-1.56 1.563Z"/>
    <path d="M21.735 23.291a1 1 0 0 1-1.416 0L12 14.957l-8.319 8.334a1 1 0 0 1-1.416 0l-1.56-1.563a1 1 0 0 1 0-1.413L11.292 9.709a1 1 0 0 1 1.416 0l10.587 10.606a1 1 0 0 1 0 1.413l-1.56 1.563Z"/>
  </g>
  <defs>
    <clipPath id="chevron-up-double__a">
      <path d="M0 0h24v24H0z"/>
    </clipPath>
  </defs>
</svg>
